module.exports = __webpack_public_path__ + "static/media/animal_music_band.611f0677.png";